import Vue from 'vue'
import Router from 'vue-router'
import ProfilePage from '@/components/profile-page/profile-page.vue'
import TicketsAndBar from '@/components/tickets-and-bar/wrapper.vue'
// import MFriends from '@/components/m-friends/wrapper.vue'
import Login from '@/components/login/wrapper.vue'
import FBLogin from '@/components/login/fb-login.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Tickets & bar',
      component: TicketsAndBar
    },
    {
      path: '/profile',
      name: 'Profile',
      component: ProfilePage
    },
    {
      path: '/tickets',
      name: 'Tickets & bar',
      component: TicketsAndBar
    },
    // {
    //   path: '/friends',
    //   name: 'M Friends',
    //   component: MFriends
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/fb-login',
      name: 'FBLogin',
      component: FBLogin
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js